export const InitResultsCardCarousels = () => {
  const carousels = document.querySelectorAll('.results_card.media_type_carousel .carousel');

  if(carousels.length){
    carousels.forEach(carousel => {
      carousel.carousel = new resultsCarousel(carousel);
    });
  }
}


class resultsCarousel {
  constructor(el) {
    this.el = el;
    this.slides = el.querySelectorAll('.media-block-lazy-wrap');
    this.navButtons = el.querySelectorAll('.results_card__pagination button');
    this.speed = 5000;
    this.animationTiming = 1500;
    this.navigationPaused = false;

    if(!this.slides.length){
      return;
    }

    // Track the active slide
    this.setActiveSlide();

    // Start the carousel
    this.play();

    // Watch navigation clicks
    this.navigationClicks();
  }

  setActiveSlide(index = 0) {
    if(index > (this.slides.length - 1)){
      index = 0;
    }

    this.activeSlideIndex = index; 
    this.activeSlide = this.slides[index];

    this.activeSlide.classList.add('active');
    this.activeSlide.setAttribute('aria-hidden', 'false');

    this.slides.forEach((slide, slideIndex) => {
      if(slideIndex !== index){
        if(slide.classList.contains('active')){
          slide.classList.add('fade_out');
          setTimeout(() => {
            slide.classList.remove('active');
            slide.classList.remove('fade_out');
          }, this.animationTiming);
        }
        if(slide.getAttribute('aria-hidden') !== 'true'){
          slide.setAttribute('aria-hidden', 'true');
        }
      }
    });
  }

  getNextIndex(){
    return (this.activeSlideIndex + 1) == this.slides.length ? 0 : this.activeSlideIndex + 1;
  }

  getPrevIndex(){
    return this.activeSlideIndex == 0 ? (this.slides.length - 1) : this.activeSlideIndex - 1;
  }

  play() {
    this.interval = setInterval(() => {
      this.setActiveSlide(this.getNextIndex());
    }, this.speed);
  }

  goToSlide(index){
    clearInterval(this.interval);
    this.setActiveSlide(index);
    this.play();
  }

  navigationClicks() {
    if(this.navButtons.length){
      this.navButtons.forEach(button => {
        button.addEventListener('click', () => {
          if(!this.navigationPaused){
            this.navigationPaused = true;
            const newSlideIndex = button.classList.contains('next') ? this.getNextIndex() : this.getPrevIndex();
            this.goToSlide(newSlideIndex);

            setTimeout(() => {
              this.navigationPaused = false;
            }, this.animationTiming);
          }
        });
      });
    }
  }
}